import { SxProps } from '@mui/material'

import theme from '../../styles/themes/default.theme'

const styles = {
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  } as SxProps,

  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  } as SxProps,

  sectionTitle: {
    fontWeight: 600,
    fontSize: '1.1rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5)
  } as SxProps,

  infoRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  } as SxProps,

  infoLabel: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  } as SxProps,

  infoValue: {
    color: theme.palette.text.primary,
    fontSize: '1rem'
  } as SxProps,

  codeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(1),
    border: `2px solid ${theme.palette.primary.main}`
  } as SxProps,

  codeText: {
    flex: 1,
    fontSize: '1.5rem',
    fontWeight: 600,
    fontFamily: 'monospace',
    color: theme.palette.primary.main,
    letterSpacing: '0.1em'
  } as SxProps,

  doorAssignmentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  } as SxProps,

  doorAssignment: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2)
  } as SxProps,

  mapButton: {
    marginTop: theme.spacing(1)
  } as SxProps,

  purpleCodeContainer: {
    backgroundColor: theme.palette.tertiary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2)
  } as SxProps,

  purpleCodeText: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'transparent',
      '& input': {
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: '1.5rem',
        letterSpacing: '0.1em',
        textAlign: 'left',
        padding: theme.spacing(1),
        fontFamily: 'monospace'
      },
      '& fieldset': {
        border: 'none'
      }
    }
  } as SxProps
}

export default styles
